export default __webpack_public_path__ + "static/media/property_1_20.1a991a6c.webp";